import {useEffect, useState} from 'react';

function formatRemaining(ms: number): string {
  if (ms <= 0) return 'Expired';

  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts: string[] = [];
  if (days > 0) parts.push(`${days} Day${days === 1 ? '' : 's'}`);
  if (hours > 0 || days > 0) parts.push(`${hours} Hour${hours === 1 ? '' : 's'}`);
  if (minutes > 0 || hours > 0 || days > 0) {
    parts.push(`${minutes} Minute${minutes === 1 ? '' : 's'}`);
  }
  if (days === 0 && hours === 0) {
    parts.push(`${seconds} Second${seconds === 1 ? '' : 's'}`);
  }

  return parts.slice(0, 3).join(', ');
}

export function useExpiryCountdown(expiresAt: string | null): string {
  const [label, setLabel] = useState('');

  useEffect(() => {
    if (!expiresAt) {
      setLabel('');
      return;
    }

    const tick = () => {
      const remaining = new Date(expiresAt).getTime() - Date.now();
      setLabel(formatRemaining(remaining));
    };

    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [expiresAt]);

  return label;
}
